import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import productEndpoints from '../api/productEndpoints'
import productQueryKeys from '../queries/productQueryKeys'
import integrationRequest from '../../../services/api/integrationRequest'
import { Product } from '../../../types/product/product'

export const getProducts = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof productQueryKeys)['list']>>): Promise<Product[]> => {
  if (!companyId || companyId === 'undefined') return []
  return integrationRequest<Product[]>({
    method: GET,
    url: productEndpoints.accounting(),
    signal,
    params: {
      companyId
    }
  })
}
